<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :before-close="resetValidation('blog')"
      @close="close"
      @open="open"
    >
      <el-form ref="blog" id="blog-form" :model="blog" label-position="top">
        <el-form-item
          label="Name"
          prop="author_id"
          :rules="[{ required: true, message: 'name is required' }]"
        >
          <el-select v-model="blog.author_id" clearable filterable class="mr10">
            <el-option
              v-for="a in authors.data"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Title" ref="title" prop="title" required>
          <el-input type="text" v-model="blog.title" clearable />
        </el-form-item>
        <el-form-item label="Subtitle" ref="subtitle" prop="subtitle">
          <el-input type="text" v-model="blog.subtitle" clearable />
        </el-form-item>
        <div>
          <p class="inline-eye"><span class="required-star">*</span>Text</p>
          <i class="el-icon-view ml10" @click="openPreview(blog.text)"></i>
        </div>
        <el-form-item prop="text">
          <vue-editor v-model="blog.text" :editorToolbar="customToolbar" />
        </el-form-item>
        <div>
          <p class="inline-eye"><span class="required-star">*</span>Short Text</p>
          <i
            class="el-icon-view ml10"
            @click="openPreview(blog.short_text)"
          ></i>
        </div>
        <el-form-item prop="short_text" required>
          <vue-editor
            v-model="blog.short_text"
            :editorToolbar="customToolbar"
          />
        </el-form-item>
        <p>Image</p>
        <el-upload
          :action="`${url}cms/blog/upload`"
          :headers="headers"
          accept="image/*"
          :on-success="onSuccess"
          :on-error="onError"
          :on-remove="onRemove"
          :on-exceed="onExceed"
          :limit="1"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">Click to upload</el-button>
          <div slot="tip" class="el-upload__tip">jpg/jpeg/png/gif files</div>
        </el-upload>
        <p>Schedule blog post</p>
        <el-date-picker v-model="blog.publish_time" type="date" placeholder="Select publish date"
                    :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">
        </el-date-picker>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
          :disabled="!blog.text || !blog.short_text || !blog.title || !blog.author_id"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },

  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      image: { name: '', url: '' }
    }
  },

  computed: {
    dialogTitle: function() {
      if (typeof this.blog.id !== 'undefined' && this.blog.id !== null)
        return 'Edit Blog'
      else {
        return 'Insert Blog'
      }
    },
    ...mapState('blog', ['loading', 'blog', 'authors', 'data', 'dialog'])
  },

  methods: {
    ...mapActions('blog', ['update', 'insert', 'getAuthors']),
    ...mapMutations('blog', ['setSelectedBlog', 'setDialog']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      if (typeof this.blog.id !== 'undefined' && this.blog.id !== null)
        this.update(this.blog.id)
      else this.insert()
    },

    onSuccess(response, file) {
      this.blog.image_url = response.response.message
      this.$message({
        type: 'success',
        message: `File ${file.name} uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.blog.image_url = null
    },

    onExceed() {
      this.$message({
        type: 'error',
        message: 'Only one image can be uploaded'
      })
    },

    open() {
      this.fileList = []
      if (
        typeof this.blog.image_url !== 'undefined' &&
        this.blog.image_url !== null
      ) {
        this.image.url = this.blog.image_url
        //this.image.name = this.image.url.substr(this.image.url.lastIndexOf("/")+1)
        this.fileList.push(this.image)
      }
    },

    resetValidation(formName) {
      if (typeof this.$refs[formName] != 'undefined') {
        this.$refs[formName].fields.find(f => f.prop == 'title').clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'author_id')
          .clearValidate()
      }
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    close() {
      this.setDialog(false)
    }
  },

  created() {
    this.getAuthors()
  }
}
</script>

<style scoped>
.inline-eye {
  font-size: 16px;
  color: #0E0525;
}
.required-star {
  color: #d06e6e;
  margin-right: 4px;
}
.inline-eye {
  display: inline-block;
}
</style>
